// extracted by mini-css-extract-plugin
export default {"column-container":"style_column-container__AGluW","column-wrapper":"style_column-wrapper__cVrDe","column":"style_column__t5LZW","title-container":"style_title-container__JluzR"};